module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "product"
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    staticClass: "btn wow1",
    attrs: {
      "onclick": "trackWaitJump('btn_shop','https://docs.google.com/forms/d/e/1FAIpQLSdCrNZQ9prbqQPgSbaeytIQBKWXAfFtFQA3xICoG5OR5jQUqA/viewform')"
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 55.2 46.2"
    }
  }, [_c('title', [_vm._v("store")]), _vm._v(" "), _c('g', {
    attrs: {
      "data-name": "store"
    }
  }, [_c('path', {
    attrs: {
      "d": "M54.9,16.4L51.2,2.7C50.6,1.1,49,0,47.2,0H9c-1.8,0-3.4,1.1-4,2.8L0.3,16.3c-0.9,2.3-0.1,4.9,1.8,6.2c0.7,0.5,1.5,0.8,2.3,0.9v18.6c0,2.3,1.8,4.1,4,4.1h11.1h16.2h10.9c2.2,0,4-1.9,4-4.1V23.5c0.8-0.1,1.6-0.5,2.3-0.9C55,21.2,55.7,18.7,54.9,16.4zM21.4,43V32.2c0-1,0.8-1.8,1.8-1.8h9c1,0,1.8,0.8,1.8,1.8V43H21.4z M32.2,27.1h-9c-2.8,0-5,2.3-5,5V43H8.5c-0.4,0-0.7-0.4-0.7-0.9v-19C8.4,22.9,9,22.5,9.5,22c1.9-1.8,4.9-1.8,6.7,0c2.2,2.1,5.9,2.1,8,0c1.9-1.8,4.9-1.8,6.7,0c2.1,2,5.9,2,8,0c1.9-1.8,4.9-1.8,6.7,0c0.5,0.5,1.1,0.9,1.8,1.1v18.9c0,0.5-0.3,0.9-0.7,0.9h-9.5V32.2C37.2,29.4,34.9,27.1,32.2,27.1z M47.9,19.7c-1.5-1.4-3.5-2.2-5.6-2.2c-2.1,0-4.1,0.8-5.6,2.2c-0.9,0.9-2.6,0.9-3.6,0c-3.1-2.9-8.1-2.9-11.2,0c-0.9,0.9-2.6,0.9-3.6,0c-3.1-2.9-8.1-2.9-11.2,0C6.4,20.5,5,20.6,4,19.9c-0.7-0.5-1-1.5-0.6-2.5L8,3.8C8.1,3.5,8.5,3.2,9,3.2h38.2c0.5,0,0.8,0.3,0.9,0.5l3.7,13.6l0,0.1c0.3,0.9,0.1,1.9-0.6,2.5C50.2,20.6,48.8,20.5,47.9,19.7z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "10.4",
      "y": "8.6",
      "transform": "matrix(0.329 -0.9443 0.9443 0.329 0.1869 20.699)",
      "width": "8.5",
      "height": "3.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "26",
      "y": "6.1",
      "width": "3.2",
      "height": "8.2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "39",
      "y": "6",
      "transform": "matrix(0.9443 -0.329 0.329 0.9443 -1.0973 13.9515)",
      "width": "3.2",
      "height": "8.5"
    }
  })])])]), _c('span', [_vm._v("選購 多寶生活好品")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookmark"
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/bookmark/v/product.svg"),
      "alt": "多寶商品"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "txtcontent strip"
  }, [_c('h2', {
    staticClass: "wow1"
  }, [_c('img', {
    staticClass: "secondtxt",
    attrs: {
      "src": require("../../asset/svg/title/product.svg"),
      "alt": "多寶生活好品"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "wow2"
  }, [_vm._v(" 讓我們的日常擁有不一樣的美好")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productpic"
  }, [_c('img', {
    staticClass: "wow3",
    attrs: {
      "src": require("../../img/product_pic.jpg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3187f92c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/Product.vue
// module id = 247
// module chunks = 0